import { render, staticRenderFns } from "./NewOrdersFileModal.vue?vue&type=template&id=65845122&"
import script from "./NewOrdersFileModal.vue?vue&type=script&lang=js&"
export * from "./NewOrdersFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewOrdersFileModal.vue"
export default component.exports